import student1 from '../assets/Speakers/Johan Lorentz.jpg'
import student2 from '../assets/Speakers/Hanish Azhakanthara Hari.jpg'
import student3 from '../assets/Speakers/Gifty Johnson.png'
import student4 from '../assets/Speakers/Jilna George.jpg'
import student5 from '../assets/Speakers/Sreelekshmi Balakrishna Pillai.jpg'
import student6 from '../assets/Speakers/Jayitha Ottakath.jpg'
import student7 from '../assets/Speakers/Ruddy Jinto_.jpg'
import student8 from '../assets/Speakers/Neethukrishna Jayakumar Bindhu.jpg'
import student9 from '../assets/Speakers/Anu Thomas.jpg'
import student10 from '../assets/Speakers/Archa Prasannan.jpg'
import student11 from '../assets/Speakers/Meera Madhu.jpg'
import student12 from '../assets/Speakers/Rahul Thazhathuvalappil Murali.jpeg'
import student13 from '../assets/Speakers/Anupriya Xavier_.jpg'
import student14 from '../assets/Speakers/Cynthia Jon-Olawuyi.png'
import student15 from '../assets/Speakers/Edvard Nylen.JPG'
import student16 from '../assets/Speakers/Rosemary Palliparambil Johny.jpg'
import student17 from '../assets/Speakers/Batoul Hammoud.jpg'
import student18 from '../assets/Speakers/Nikhil Thampan.jpg'
import student19 from '../assets/Speakers/Palpolage Don Charitha Gunathilake.jpg'
import student20 from '../assets/Speakers/Akhila Suresh Babu Nair.jpg'
import student21 from '../assets/Speakers/Syama Sivasankarapillai.jpg'
import student22 from '../assets/Speakers/Deepamol Manathrakadavil Balachandran.jpg'
import student02 from '../assets/Speakers/Sebastian Persson.jpg'
import student012 from '../assets/Speakers/Rousitamu Aihetamu.jpg'






export default [
   {
   name:'Johan Lorentz',
   role:'Student',
   image:student1
   },
   {
    name:'Sebastian Persson',
    role:'Student',
    image:student02
    },
   {
     name:'Hanish Azhakanthara Hari',
     role:'Student',
     image:student2
   },
   {
     name:'Gifty Johnson',
     role:'Student',
     image:student3
   },
   {
     name:'Jilna George',
     role:'Student',
     image:student4
   },
   {
    name:'Sreelekshmi Balakrishna Pillai',
    role:'Student',
    image: student5
   },
   {
    name:'Jayitha Ottakath',
    role:'Student',
    image: student6
   },
   {
    name:'Ruddy Jinto',
    role:'Student',
    image:student7 
   },
   {
    name:'Neethukrishna Jayakumar Bindhu',
    role:'Student',
    image:student8 
   },
   {
    name:'Anu Thomas',
    role:'Student',
    image:student9 
   },
   {
    name:'Archa Prasannan',
    role:'Student',
    image:student10 
   },
   {
    name:'Meera Madhu',
    role:'Student',
    image: student11
   },
   {
    name:'Rousitamu Aihetamu',
    role:'Student',
    image:student012
    },
   {
    name:'Rahul Thazhathuvalappil Murali',
    role:'Student',
    image:student12 
   },
   {
    name:'Anupriya Xavier',
    role:'Student',
    image:student13 
   },
   {
    name:'Cynthia Jon-Olawuyi',
    role:'Student',
    image:student14 
   },
   {
    name:'Edward Nylén',
    role:'Student',
    image:student15 
   },
   {
    name:'Rosemary Palliparambil Johny',
    role:'Student',
    image:student16 
   },
   {
    name:'Batoul Hammoud',
    role:'Student',
    image:student17
   },
   {
    name:'Nikhil Thampan',
    role:'Student',
    image: student18
   },
   {
    name:'Palpolage Don Charitha Gunathilake',
    role:'Student',
    image: student19
   },
   {
    name:'Akhila Suresh Babu Nair',
    role:'Student',
    image: student20
   },
   {
    name:'Syama Sivasankarapillai',
    role:'Student',
    image:student21 
   },
   {
    name:'Deepamol Manathrakadavil Balachandran',
    role:'Student',
    image: student22
   },
   
]